export default __webpack_public_path__ + "static/front-1fc14842abbfe986950daf4915fd1ecb.webp";